import React from 'react';
import { useTranslation } from 'react-i18next';
import { LoadingButton } from '@redpanda/ui';

interface BulkActionButtonProps {
  selectedCount: number;
  loading: boolean;
  onClick: () => void;
  className?: string;
  entityName?: string;
  disabled?: boolean;
  disabledMessage?: string;
}

const BulkActionButton: React.FC<BulkActionButtonProps> = ({
  selectedCount,
  loading,
  onClick,
  className = '',
  entityName = '項目',
  disabled = false,
  disabledMessage
}) => {
  const { t } = useTranslation();

  if (selectedCount === 0) return null;

  return (
    <div className="flex items-center space-x-3">
      <span className="text-sm text-gray-700 dark:text-white font-medium">
        {t('common.bulk.selectedCount', { count: selectedCount })}
      </span>

      <div className="flex space-x-2">
        <LoadingButton
          type="button"
          loading={loading}
          disabled={disabled}
          onClick={onClick}
          title={disabled && disabledMessage ? disabledMessage : ''}
          className={`${
            disabled
              ? 'bg-gray-400 cursor-not-allowed text-white'
              : 'bg-red-600 hover:bg-red-700 disabled:bg-red-400 text-white'
          } font-bold py-2 px-4 rounded ${className}`}
        >
          {t('common.bulk.deleteAction')} ({selectedCount})
        </LoadingButton>
      </div>
    </div>
  );
};

export default BulkActionButton;